import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    standalone: false,
  selector: 'integration-aws-config',
  templateUrl: './integration-aws-config.component.html',
  styleUrls: ['./integration-aws-config.component.css'],
})
export class IntegrationAwsConfigComponent implements OnInit {
  @Input() settingsForm: FormGroup;
  @Input() settings: any;

  public fields = [
    {'id': 'accessKey', 'name': 'Access Key'},
    {'id': 'secretKey', 'name': 'Secret Key'},
    {'id': 'region', 'name': 'Region'},
    {'id': 'resourceId', 'name': 'Resource ID'},
    {'id': 'resourceType', 'name': 'Resource Type'}
  ];

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    for(var field of this.fields) {
      this.settingsForm.addControl(
        field.id,
        this.fb.control('', Validators.required)
      );
    }

    this.settingsForm.patchValue(this.settings);
  }
}
